import React, { useEffect, useMemo, useState } from 'react'
import { AlertType, DadosRelDiaCtaPagar, RetAPI, VendasRelatorio, bgLineGridColorDark, bgLineGridColorLight, contaAPagar, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { ContaAPagarService } from '../../Pages/ContasAPagar/ContaAPagarService'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { IoCreate, IoTrash } from 'react-icons/io5'
import { Funcoes } from '../../Utils/Funcoes'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

type Props = {
    relVendaPeriodo: VendasRelatorio[],
}

interface RowData {

    bairro_consumidor: string,
    cep_consumidor: string,
    cpf_cnpj: string,
    data_hora: string,
    dh_cancel: string,
    dh_faturamento: string,
    dt_last_update: string,
    id: number,
    id_cidade_consumidor: number,
    id_cliente: number,
    id_empresa: number
    id_user_cancel: number,
    id_user_faturamento: number,
    id_user_insert: number,
    id_user_last_update: number,
    name_user_insert: string,
    nome_cliente: string,
    nome_consumidor: string,
    num_nf: string,
    numero_consumidor: string,
    observacao: string,
    qtd_itens: number,
    rua_consumidor: string,
    status: string,
    vl_acre: number,
    vl_bc_icms: number,
    vl_bc_pis_cofins: number,
    vl_bc_st: number,
    vl_bruto: number,
    vl_cofins: number,
    vl_desc: number,
    vl_frete: number,
    vl_icms: number,
    vl_liquido: number,
    vl_pis: number,
    vl_st: number,
}

type VisibilityState = Record<string, boolean>

export const GridRelPeriodoVenda = React.memo(({ relVendaPeriodo }: Props) => {

    const xJson = localStorage.getItem("@commerce/column_grid_rel_venda_periodo")

    let json: any = {
        id: true,
        vl_bruto: true,
        vl_desc: true,
        vl_liquido: true,
        qtd_itens: true,
        nome_cliente: true,
        data_hora: true,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_rel_venda_periodo") || '')
    }

    //const [feedBackVisible, setFeedBackVisible] = useState(false)
    //const [messageFeedBack, setMessageFeedBack] = useState("")
    //const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(json)

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light'
                        ? '#fff' // modo claro
                        : '#475569', //modo escuro
            },
        },
    })

    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.id = json.id
                newColumnVisibility.vl_bruto = json.vl_bruto
                newColumnVisibility.vl_desc = json.vl_desc
                newColumnVisibility.vl_liquido = json.vl_liquido
                newColumnVisibility.qtd_itens = json.qtd_itens
                newColumnVisibility.nome_cliente = json.nome_cliente
                newColumnVisibility.data_hora = json.data_hora  
            }
        }
    }, [])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_rel_venda_periodo", JSON.stringify(columnVisibility))
    }, [columnVisibility])

    const baseBackgroundColor =
        user.modeDark === 'dark'
            ? '#475569'
            : '#fff'

    const colunas = useMemo<MRT_ColumnDef<VendasRelatorio>[]>(
        () => [

            {
                accessorKey: 'id', header: 'Venda', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.id ? rowData.id : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'nome_cliente', header: 'Nome Cliente', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.nome_cliente ? rowData.nome_cliente : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'vl_bruto', header: 'Valor Bruto', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_bruto ? Funcoes.numberFormat(rowData.vl_bruto, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'vl_desc', header: 'Valor Desconto', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_desc ? Funcoes.numberFormat(rowData.vl_desc, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'vl_liquido', header: 'Valor Líquido', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_liquido ? Funcoes.numberFormat(rowData.vl_liquido, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'qtd_itens', header: 'Qtde Itens', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.qtd_itens ? rowData.qtd_itens : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'data_hora', visibleInShowHideMenu: true, header: 'Data', size: 150, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },
    
                Cell: (cell: any) => {
    
                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.data_hora ? moment(rowData.data_hora).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },



        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: relVendaPeriodo,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table}/>

            </ThemeProvider>

        </>
    )

})